export class StringUtils {
  public static primeiraLetraMaiuscula(string: string) {
    if (!string) {
      return;
    }

    return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
  }
}
